import { Component, Input } from '@angular/core';
import { BrowserService, AppAuthentication, AppUser } from 'app-shared/kmc-shell';

import { PopupWidgetComponent } from '@kaltura-ng/kaltura-ui';
import { Router } from '@angular/router';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { kmcAppConfig } from '../../kmc-app-config';

@Component({
  selector: 'kKMCUserSettings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
})
export class UserSettingsComponent {
  @Input() parentPopup: PopupWidgetComponent;

  public _languages = [];

  public _dateFormats = [
    { value: 'day-month-year', label: this._appLocalization.get('app.userSettings.dayMonthYear') },
    { value: 'month-day-year', label: this._appLocalization.get('app.userSettings.monthDayYear') },
  ];

  public _selectedLanguage = 'ru';

  public _selectedDateFormat = this.browserService.getFromLocalStorage('kmc_date_format') || 'day-month-year';

  constructor(
    private _appLocalization: AppLocalization,
    public _userAuthentication: AppAuthentication,
    private browserService: BrowserService,
    private _router: Router,
  ) {
    kmcAppConfig.locales.forEach((locale) => {
      this._languages.push({ label: locale.label, value: locale.id });
    });

    const currentLang = this.browserService.getFromLocalStorage('kmc_lang');
    if (currentLang && currentLang.length) {
      const lang = this._languages.find((lang) => lang.value === currentLang);
      if (lang) {
        this._selectedLanguage = lang.value;
      }
    }
  }

  logout() {
    this._userAuthentication.logout();
  }

  onLangSelected(event) {
    this.browserService.setInLocalStorage('kmc_lang', event.value);
    this._userAuthentication.reload();
  }

  onDateFormatSelected(event: { value: string }): void {
    this.browserService.setInLocalStorage('kmc_date_format', event.value);
    this._userAuthentication.reload();
  }

  egg() {
    this._router.navigateByUrl(kmcAppConfig.routing.errorRoute, { replaceUrl: true });
  }
}
